import { apiFetch } from '$lib/api/helpers';
import type { RCUChannelPatch, RCUChannelResponse } from '$lib/types/rcu_channel';

const PATH = '/rcu_channels/';

export async function fetchRCUChannels() {
  return apiFetch<Array<RCUChannelResponse>>(PATH);
}

export async function fetchRCUChannelsByRCU(rcuId: number) {
  return apiFetch<Array<RCUChannelResponse>>(`${PATH}?rcu_id=${rcuId}`);
}

export async function fetchRCUChannelById(id: number) {
  return apiFetch<RCUChannelResponse>(`${PATH}${id}/`);
}

export async function createRCUChannel(data: {
  rcu: number;
  channel_number: number;
  load?: number | null;
}) {
  return apiFetch<RCUChannelResponse>(PATH, {
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export async function updateRCUChannel(
  id: number,
  data: Partial<{ rcu: number; channel_number: number; load: number | null }>
) {
  return apiFetch<RCUChannelResponse>(`${PATH}${id}/`, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
}

export async function patchRCUChannel(id: number, patch: RCUChannelPatch) {
  return apiFetch<RCUChannelResponse>(`${PATH}${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(patch)
  });
}

export async function deleteRCUChannel(id: number) {
  return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}
